import { useMediaQuery } from '@space-core/hooks'
import { customMedia, ScreenSizes } from '@space-core/styles'
import useFeatureToggle from '@space-shell/common/hooks/useFeatureToggle'
import useRequest from '@space-shell/common/hooks/useRequest'

import { LiveService, LiveEndpoints } from '@space-shell/common/services/live'
import { Toggles } from '@space-shell/common/services/toggle'
import { RoutesPaths } from '@space-shell/core/router/constants'
import { generatePath, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { MultiLiveCard, SingleLiveCard } from './components'

const LivesContainer = styled.div`
  gap: 1.5rem;

  ${customMedia.lessThan('md')`
    flex-direction: column
  `}
`

const Live = () => {
  const { lang, membership } = useParams<{ lang: string; membership?: string }>()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)
  const membershipParam = membership as string

  const { data: isLiveOnMF } = useFeatureToggle({ toggleName: Toggles.EnableClubLiveMicrofront })

  const { data: livesMembership } = useRequest([LiveEndpoints.lives(membershipParam)], () =>
    LiveService.getLives(membershipParam)
  )

  const isLivesEmpty = !livesMembership || livesMembership?.length === 0
  const isSingleLive = livesMembership?.length === 1

  if (isLivesEmpty) {
    return null
  }

  if (isSingleLive && !isMobile) {
    const { code, productId, productName, liveName, liveUrl, smallUrlThumbnail } =
      livesMembership[0]

    const liveUrlOnMF = generatePath(`${RoutesPaths.HOME}/products/:productId/live/:code`, {
      lang,
      membership: membershipParam,
      productId: String(productId),
      code
    })

    const currentLiveUrl = isLiveOnMF ? liveUrlOnMF : liveUrl

    return (
      <div className='_mb-6 _px-4 _px-md-10'>
        <SingleLiveCard
          productName={productName}
          liveName={liveName}
          liveUrl={currentLiveUrl}
          smallUrlThumbnail={smallUrlThumbnail}
          isLiveOnMF={Boolean(isLiveOnMF)}
        />
      </div>
    )
  }

  return (
    <LivesContainer className='_d-flex _mb-6 _px-4 _px-md-10'>
      {livesMembership?.map(({ code, productName, liveName, liveUrl, smallUrlThumbnail }) => {
        return (
          <MultiLiveCard
            key={code}
            productName={productName}
            liveName={liveName}
            liveUrl={liveUrl}
            smallUrlThumbnail={smallUrlThumbnail}
            size={livesMembership?.length}
          />
        )
      })}
    </LivesContainer>
  )
}

export default Live
